export default __webpack_public_path__ + "static/media/range2.7b90dedd.jpeg";